export default __webpack_public_path__ + "static/media/Chatris.e5fd5eba.jpg";